import React, { useEffect, useState } from "react";
import "./index.less";
import { useLocation } from "react-router-dom";
import { searchTargetCoordinate, updateParamModel, updateCurrentLanguage } from "@/redux/actions/commonAction";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/reducer/store";
import { Modal } from "antd";

interface WidgetParams {
    latitude: string;
    longitude: string;
    numberOfDays: string;
    unit: string;
    language: string;
    countryCode: string;
    backfillValue: string;
}

const ForcastWeatherWidget = () => {
    const dispatch = useDispatch();
    const {
        paramModel,
        currentLanguage,
        searchCoordinateResult
    } = useSelector((state: RootState) => state.commonReducer);

    console.log("paramModel in ForecastWeatherWidget:", paramModel);
    console.log("searchCoordinateResult in ForecastWeatherWidget:", searchCoordinateResult);
    console.log("currentLanguage in ForecastWeatherWidget:", currentLanguage);
    // 获取URL参数
    const urlLocation = useLocation();
    useEffect(() => {
        const securityReg = /(?<=securitykey=)[\w\\/+=]*/i;
        const themeReg = /(?<=theme=)[\w]*/i;
        const countryCodeReg = /(?<=country=)[\w]*/i;
        const latitudeReg = /(?<=[Ll]at=)[+-.\w]*/i;
        const longitudeReg = /(?<=[Ll]ong=)[+-.\w]*/i;
        const languageReg = /(?<=[Ll]anguage=)[\w]*/i;
        const numberOfDaysReg = /(?<=numberofforecast=)[\w]*/i;
        const unitReg = /(?<=unit=)[\w]*/i;
        const placenameReg = /placename=([^&]+)/i;
        const modelNameReg = /(?<=[Uu]ser[Ss]praywdws=)[\w]*/;

        const securityRes = urlLocation.search.match(securityReg);
        const themeRes = urlLocation.search.match(themeReg);
        const modelNameRes = urlLocation.search.match(modelNameReg);
        const countryCodeRes = urlLocation.search.match(countryCodeReg);
        const latitudeRes = urlLocation.search.match(latitudeReg);
        const longitudeRes = urlLocation.search.match(longitudeReg);
        const languageRes = urlLocation.search.match(languageReg);
        const numberOfDaysRes = urlLocation.search.match(numberOfDaysReg);
        const unitRes = urlLocation.search.match(unitReg);
        const placenameRes = urlLocation.search.match(placenameReg);

        const security = securityRes ? securityRes[0] : "no-value";
        const theme = (themeRes && themeRes[0] ? themeRes[0]?.toLowerCase() : "light");
        const countryCode = countryCodeRes && countryCodeRes[0] ? countryCodeRes[0]?.toUpperCase() : "GB";
        const latitude = parseFloat(latitudeRes[0] || "0");
        const longitude = parseFloat(longitudeRes[0] || "0");
        const language = languageRes && languageRes[0] ? languageRes[0]?.toLowerCase() : "en";
        const numberOfDays = numberOfDaysRes && numberOfDaysRes[0] ? parseFloat(numberOfDaysRes[0]) : 1;
        const unit = unitRes && unitRes[0] ? unitRes[0]?.toLowerCase() : "metric";
        const placename = placenameRes && placenameRes[1] || null;
        const modelName = modelNameRes && modelNameRes[0];

        dispatch(updateParamModel({
            security,
            theme,
            modelName,
            countryCode,
            latitude,
            longitude,
            language,
            numberOfDays,
            unit,
            placename
        }));

        if (theme) {
            const rootElement = document.getElementById("root");
            switch (theme) {
                case "dark": {
                    rootElement.className = "dark-theme";
                    break;
                }
                case "light": {
                    rootElement.className = "light-theme";
                    break;
                }
            }
        }
    }, [urlLocation]);

    // 初始参数（只在paramModel变化时更新）
    const [widgetParams, setWidgetParams] = useState<WidgetParams>({
        latitude: "",
        longitude: "",
        numberOfDays: "",
        unit: "",
        language: "",
        countryCode: "",
        backfillValue: "",
    });

    useEffect(() => {
        if (paramModel) {
            setWidgetParams({
                latitude: paramModel.latitude != null ? paramModel.latitude.toString() : "",
                longitude: paramModel.longitude != null ? paramModel.longitude.toString() : "",
                numberOfDays: paramModel.numberOfDays != null ? paramModel.numberOfDays.toString() : "3",
                unit: paramModel.unit ?? "metric",
                language: paramModel.language ?? "",
                countryCode: paramModel.countryCode ?? "",
                backfillValue: "",
            });
            setWidgetKey(`${paramModel.latitude != null ?
                paramModel.latitude.toString() : ""}-${paramModel.longitude != null ?
                    paramModel.longitude.toString() : ""}`);
        }
    }, [paramModel]);

    // 监听location-search-widget返回
    useEffect(() => {
        customElements.whenDefined("location-search-widget").then(() => {
            const handlePositionCallback = (event: CustomEvent) => {
                const detail = event.detail;
                console.log("positionCallback event received:", detail);
                console.log("typeof detail:", typeof detail, "Array.isArray:", Array.isArray(detail), "length:", Array.isArray(detail) ? detail.length : undefined);
                // 如果detail为数组且为空，弹出提示框
                if ((Array.isArray(detail) && detail.length === 0) || detail === null || detail === undefined || detail === "no result") {
                    dispatch(searchTargetCoordinate(true)); //标题，ok按钮和cancel显示语言不正确
                    return;
                }
                // 只有detail为对象（用户选中某个地点）时才赋值
                if (detail && !Array.isArray(detail)) {
                    const lat = detail.latitude?.toString() ?? "";
                    const lon = detail.longitude?.toString() ?? "";
                    const name = detail.name ?? "";
                    console.log("Updating widgetParams with:", { lat, lon, name });
                    setWidgetParams(prev => ({
                        ...prev,
                        latitude: lat,
                        longitude: lon,
                        backfillValue: name,
                    }));
                }
            };
            document.addEventListener("positionCallback", handlePositionCallback as EventListener);
            return () => {
                document.removeEventListener("positionCallback", handlePositionCallback as EventListener);
            };
        });
    }, []);

    // 生成唯一key
    //const widgetKey = `${widgetParams.latitude}-${widgetParams.longitude}`;
    const [widgetKey, setWidgetKey] = useState(`${widgetParams.latitude}-${widgetParams.longitude}`);
    console.log("change widgetKey:", widgetKey);
    console.log("change widgetParams:", widgetParams);
    return (
        <> {/* It is search location warning modal*/}
            <Modal
                title={null}
                open={searchCoordinateResult}
                onCancel={() => {
                    dispatch(searchTargetCoordinate(false));
                }}
                footer={null}
            >
                <label>{currentLanguage.No_place_found}</label>
            </Modal>
            <div className="forecast-weather-widget">
                <weather-widget
                    key={widgetKey}
                    lat={widgetParams.latitude}
                    lon={widgetParams.longitude}
                    number-of-days={widgetParams.numberOfDays}
                    unit={widgetParams.unit}
                    gps-enable="true"
                    language={widgetParams.language}
                    country-code={widgetParams.countryCode}
                    data-source="meteoblue"
                >
                    <location-search-widget
                        gps-enable="true"
                        language={widgetParams.language}
                        lat={widgetParams.latitude}
                        lon={widgetParams.longitude}
                        country-code={widgetParams.countryCode}
                        backfillValue={widgetParams.backfillValue}
                    />
                </weather-widget>

            </div>
        </>

    );
};

export default ForcastWeatherWidget;